var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "94.316,0 0,0 0,19.977 94.316,81.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,68.299 0,94.316 39.71,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,161.684 0,187.701 39.71,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,19.977 256,0 161.684,0 161.684,81.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,187.701 256,161.684 216.29,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "161.684,174.23 161.684,256 256,256 256,236.023  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,94.316 256,68.299 216.29,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,236.023 0,256 94.316,256 94.316,174.23  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,236.023 256,216.059 172.232,161.684 196.98,161.684 256,199.995 256,187.701    216.29,161.684 256,161.684 256,148.21 148.211,148.21 148.211,256 161.684,256 161.684,174.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "0,148.21 0,161.684 39.71,161.684 0,187.701 0,206.602 69.197,161.684 93.945,161.684    0,222.666 0,236.023 94.316,174.23 94.316,256 107.789,256 107.789,148.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "107.789,0 94.316,0 94.316,81.77 0,19.977 0,41.839 80.842,94.316 56.094,94.316 0,57.904    0,68.299 39.71,94.316 0,94.316 0,107.79 107.789,107.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,107.79 256,94.316 216.29,94.316 256,68.299 256,49.157 186.432,94.316 161.684,94.316    256,33.093 256,19.977 161.684,81.77 161.684,0 148.211,0 148.211,107.79  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,148.21 256,107.79 148.211,107.79 148.211,0 107.789,0 107.789,107.79 0,107.79    0,148.21 107.789,148.21 107.789,256 148.211,256 148.211,148.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "69.197,161.684 0,206.602 0,222.666 93.945,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "172.232,161.684 256,216.059 256,199.995 196.98,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "80.842,94.316 0,41.839 0,57.904 56.094,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "186.432,94.316 256,49.157 256,33.093 161.684,94.316  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M130.415,337.445l8.482,28l27.179-10.827c2.319-0.924,4.427,1.721,3.011,3.776l-16.603,24.089   l25.411,14.5c2.168,1.237,1.415,4.534-1.075,4.708l-29.185,2.038l4.507,28.907c0.385,2.466-2.663,3.934-4.351,2.095L128,413.184   l-19.79,21.547c-1.688,1.838-4.736,0.371-4.351-2.095l4.507-28.907L79.18,401.69c-2.49-0.174-3.242-3.471-1.075-4.708l25.411-14.5   l-16.603-24.089c-1.416-2.055,0.692-4.699,3.011-3.776l27.179,10.827l8.482-28C126.309,335.056,129.691,335.056,130.415,337.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M385.435,86.875l4.143,13.678l13.277-5.289c1.133-0.451,2.163,0.84,1.471,1.844l-8.11,11.767   l12.413,7.083c1.059,0.604,0.691,2.215-0.525,2.3l-14.257,0.996l2.202,14.121c0.188,1.205-1.301,1.921-2.125,1.024l-9.667-10.525   l-9.667,10.525c-0.825,0.898-2.313,0.181-2.125-1.024l2.202-14.121l-14.257-0.996c-1.216-0.085-1.584-1.696-0.525-2.3l12.413-7.083   l-8.11-11.767c-0.692-1.004,0.338-2.296,1.471-1.844l13.277,5.289l4.143-13.678C383.429,85.708,385.081,85.708,385.435,86.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M293.05,212.233l4.143,13.678l13.277-5.289c1.133-0.451,2.163,0.84,1.471,1.844l-8.11,11.767   l12.413,7.083c1.059,0.604,0.691,2.215-0.525,2.3l-14.257,0.996l2.202,14.121c0.188,1.205-1.301,1.922-2.125,1.024l-9.667-10.525   l-9.667,10.525c-0.825,0.898-2.313,0.181-2.125-1.024l2.202-14.121l-14.257-0.996c-1.216-0.085-1.584-1.696-0.525-2.3l12.413-7.083   l-8.11-11.767c-0.692-1.004,0.338-2.296,1.471-1.844l13.277,5.289l4.143-13.678C291.044,211.067,292.696,211.067,293.05,212.233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M472.837,146.913l4.143,13.678l13.277-5.289c1.133-0.451,2.163,0.84,1.471,1.844l-8.11,11.767   l12.413,7.083c1.059,0.604,0.691,2.215-0.525,2.3l-14.257,0.996l2.202,14.121c0.188,1.205-1.301,1.921-2.125,1.024l-9.667-10.525   l-9.667,10.525c-0.825,0.898-2.313,0.181-2.125-1.024l2.202-14.121l-14.257-0.996c-1.216-0.085-1.584-1.696-0.525-2.3l12.413-7.083   l-8.11-11.767c-0.692-1.004,0.338-2.296,1.471-1.844l13.277,5.289l4.143-13.678C470.831,145.746,472.483,145.746,472.837,146.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M385.435,368.074l4.143,13.678l13.277-5.289c1.133-0.451,2.163,0.84,1.471,1.844l-8.11,11.767   l12.413,7.083c1.059,0.604,0.691,2.215-0.525,2.3l-14.257,0.996l2.202,14.121c0.188,1.205-1.301,1.922-2.125,1.024l-9.667-10.525   l-9.667,10.525c-0.825,0.898-2.313,0.181-2.125-1.024l2.202-14.121l-14.257-0.996c-1.216-0.085-1.584-1.696-0.525-2.3l12.413-7.083   l-8.11-11.767c-0.692-1.004,0.338-2.296,1.471-1.844l13.277,5.289l4.143-13.678C383.429,366.907,385.081,366.907,385.435,368.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M417.489,246.968l-3.326,9.974l-10.513,0.081c-1.361,0.011-1.926,1.748-0.831,2.556l8.458,6.246   l-3.171,10.024c-0.411,1.298,1.067,2.371,2.174,1.58l8.553-6.114l8.553,6.114c1.107,0.792,2.585-0.282,2.174-1.58l-3.171-10.024   l8.458-6.246c1.095-0.809,0.531-2.546-0.831-2.556l-10.513-0.081l-3.326-9.974C419.746,245.677,417.919,245.677,417.489,246.968z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAu);
export default __webpack_public_path__ + "static/media/au.f0fbde540b43c0dc04fdce14f58752f6.svg";
export { ForwardRef as ReactComponent };